import BottomSheetHeader from '@components/BottomSheetHeader';
import Column from '@components/Column';
import Radio from '@components/Radio';
import Text from '@components/Text';
import styled from '@emotion/styled';
import { BottomSheet } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import useSelectScope from './hooks/useSelectScope';

declare module '@stackflow/config' {
    interface Register {
        StampScopeBottomSheet: {};
    }
}

const StampScopeBottomSheet: ActivityComponentType<'StampScopeBottomSheet'> = () => {
    const { t } = useTranslation('stamp');
    const { items, isSelected, handleSelect } = useSelectScope();
    return (
        <BottomSheet>
            <BottomSheetHeader>
                {t('scope.title')}
            </BottomSheetHeader>
            <Container spacing={2} fullWidth>
                <Text fontWeight='bold'>{t('scope.title')}</Text>
                <Column fullWidth >
                    {items?.map((item) => (
                        <ItemWrapper key={item.value}>
                            <Radio value=''
                                isSelected={isSelected(item)}
                                onChange={() => handleSelect(item)} >
                                {item.name}
                            </Radio>
                        </ItemWrapper>
                    ))}
                </Column>
            </Container>
        </BottomSheet>
    );
};

const Container = styled(Column)`
    padding: 16px 16px calc(var(--safe-area-bottom) + 16px);
`;

const ItemWrapper = styled.div`
    padding: 8px 0
`;

export default StampScopeBottomSheet;
